import React, { useState, useContext } from "react";
import { isEmpty, get, isNull } from "lodash";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import {
  PlanCards,
  SourceCard,
  ManageDistributionLayout,
  LoaderWrapper,
} from "../../../../../components";
import {
  distributionFormFields,
  getAdvancedPathWithParam,
  MANAGE_TRANSFER_ROUTES,
  MANAGE_CENSUS_ROUTES,
  manageDistributionFormNames,
  TRANSFER_STATUS,
} from "../../../../../utils";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../../abstracts";
import InvestmentDetails from "./InvestmentDetail/InvestmentDetails";
import {
  getCurrentHoldings,
  getTransferDetails,
} from "../../../../../services";
import {
  saveTransferRequest,
  manageDistributionStore,
  setTransferRequestPageData,
  setManageDistributionToastInfo,
  globalToastInfo,
  appLayoutStore,
} from "../../../../../contexts";

const initialValues = {
  isFutureContribution: false,
  transferStatus: null,
};

const TransferRequestContainer = (props) => {
  const history = useHistory();
  const { state, dispatch } = useContext(manageDistributionStore);
  const { dispatch: globalDispatch } = useContext(appLayoutStore);
  const { flow, censusId } = useRouterParams();
  const intCensusId = parseInt(censusId);
  const formName = manageDistributionFormNames.TRANSFER_REQUEST;
  const fields = distributionFormFields[formName];
  const [employeeImage, setEmployeeImage] = useState("");
  const [planDetails, setPlanDetails] = useState([]);
  const [transferDetails, setTransferDetails] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedPlanData, setSelectedPlanData] = useState({});
  const [sourceData, setSourceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { response: transferApiData, loading: loading } = useRequest({
    method: getTransferDetails,
    payload: censusId,
    defaultResponse: {},
  });

  const { response: planApiData, loading: loading1 } = useRequest({
    method: getCurrentHoldings,
    payload: censusId,
    defaultResponse: {},
  });

  useDeepEffect(() => {
    dispatch(
      setTransferRequestPageData({
        formName: "censusId",
        fieldData: censusId,
      })
    );
    let transData =
      !isEmpty(transferApiData) && transferApiData.transferDetails;
    setPlanDetails(!isEmpty(planApiData) && planApiData.transferRequestDetails);
    setTransferDetails(transData);
    setSelectedPlan(
      !isEmpty(planApiData) && !isEmpty(transData)
        ? planApiData.transferRequestDetails
            .map((_) => _.planId)
            .indexOf(transData && transData.planId)
        : !isEmpty(planApiData) &&
          planApiData.transferRequestDetails.length === 1
        ? 0
        : null
    );
  }, [censusId, planApiData, transferApiData]);

  useDeepEffect(() => {
    let planData = !isEmpty(planDetails) ? planDetails[selectedPlan] : {};
    setSelectedPlanData(planData);
    setSourceData(
      !isEmpty(planData) &&
        planData.transferSourceDetails.map((item) => {
          let isChecked =
            !isEmpty(transferDetails) &&
            transferDetails.transferSourceDetails
              .map((_) => _.sourceId)
              .includes(item.sourceId);
          return { ...item, checked: isChecked, show: isChecked };
        })
    );
  }, [planDetails, transferDetails, selectedPlan]);

  const formValues = !isEmpty(selectedPlanData)
    ? {
        id: get(transferDetails, "id", 0),
        employeeId: intCensusId,
        planId: selectedPlanData.planId,
        planName: selectedPlanData.planName,
        accountBalance: selectedPlanData.accountBalance,
        vestedBalance: selectedPlanData.vestedBalance,
        transferSourceDetails: selectedPlanData.transferSourceDetails.map(
          (itm) => {
            let data =
              !isEmpty(transferDetails) &&
              get(
                transferDetails.transferSourceDetails.filter(
                  (_) => _.sourceId === itm.sourceId
                ),
                "0"
              );
            if (!isEmpty(data)) {
              return {
                ...data,
                transferInvestmentDetails: data.transferInvestmentDetails.map(
                  (item) => {
                    let percent = get(
                      itm.transferInvestmentDetails.filter(
                        (_) => _.investmentId === item.investmentId
                      ),
                      "0.percentage"
                    );
                    return {
                      ...item,
                      currentPercentage: percent
                        ? Number(percent.toFixed(2))
                        : 0,
                    };
                  }
                ),
              };
            } else
              return (itm = {
                id: itm.id ? itm.id : 0,
                sourceId: itm.sourceId,
                sourceName: itm.sourceName,
                sourceBalance: itm.sourceBalance,
                transferInvestmentDetails: itm.transferInvestmentDetails.map(
                  (item) => {
                    return (item = {
                      id: item.id ? item.id : 0,
                      investmentId: item.investmentId,
                      investmentName: item.investmentName,
                      currentPercentage: Number(item.percentage.toFixed(2)),
                      amount: item.amount,
                      percentage: Number(item.percentage.toFixed(2)),
                    });
                  }
                ),
              });
          }
        ),
      }
    : {};

  const onChange = (idx, { values, setFieldValue }) => {
    let temp = sourceData.map((item, i) => {
      if (i === idx) {
        return {
          ...item,
          checked: !item.checked,
          show: !item.checked ? false : true,
        };
      }
      return item;
    });
    setSourceData(temp);
    let checked = temp.map((_) => _.checked);

    setFieldValue(
      fields.transferSourceDetails,
      values.transferSourceDetails.map((itm, i) => {
        if (checked[i] === false) {
          return (itm = {
            ...itm,
            transferInvestmentDetails: sourceData[
              i
            ].transferInvestmentDetails.map((i) => {
              return (i = {
                id: i.id ? i.id : 0,
                investmentId: i.investmentId,
                investmentName: i.investmentName,
                currentPercentage: Number(i.percentage.toFixed(2)),
                amount: i.amount,
                percentage: Number(i.percentage.toFixed(2)),
              });
            }),
          });
        }
        return itm;
      })
    );
  };

  const hideCard = (idx) => {
    setSourceData(
      sourceData.map((item, i) => {
        if (i === idx) {
          return { ...item, show: !item.show };
        }
        return item;
      })
    );
  };

  const getTransformedValues = (values, status) => {
    return {
      ...values,
      transferStatus: status,
      transferSourceDetails: values.transferSourceDetails.filter(
        (item, index) => sourceData[index].checked
      ),
    };
  };

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    saveTransferRequest(getTransformedValues(values, 1), false, dispatch)
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessfull) {
          dispatch(
            setTransferRequestPageData({
              formName: "currentHoldings",
              fieldData: sourceData,
            })
          );
          dispatch(
            setTransferRequestPageData({
              formName: "transferDetails",
              fieldData: response.transferDetails,
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_TRANSFER_ROUTES.TRANSFER_SUMMARY,
              pathParam: [flow, censusId],
            })
          );
        } else {
          setSubmitting(false);
          for (var i = 0; i < response.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  const saveDraft = (values, { setSubmitting }) => {
    setSubmitting(true);
    setIsLoading(true);
    saveTransferRequest(getTransformedValues(values, 1), true, dispatch)
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessfull) {
          globalDispatch(
            globalToastInfo({
              showToast: true,
              toastMessage: "Request saved successfully",
            })
          );
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: [flow, censusId],
            })
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        //error
      });
  };

  return (
    <>
      <Formik
        initialValues={{
          ...initialValues,
          ...formValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;

          const buttons = [
            {
              label: "Save as Darft",
              variant: "link",
              onClick: () => saveDraft(values, { setSubmitting }),
            },
            {
              label: "Cancel",
              variant: "secondary",
              type: "button",
              onClick: () =>
                history.push(
                  getAdvancedPathWithParam({
                    path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                    pathParam: [flow, censusId],
                  })
                ),
            },
            {
              label: "Next",
              variant: "primary",
              type: "submit",
              disabled:
                !isEmpty(sourceData) &&
                !sourceData.map((_) => _.checked).includes(true),
            },
          ];

          return (
            <Form onSubmit={handleSubmit}>
              <LoaderWrapper isLoading={isLoading || loading || loading1}>
                <ManageDistributionLayout
                  buttons={buttons}
                  layoutHeader="Transfer request"
                  employeeImage={employeeImage}
                >
                  <div className="transfer-container">
                    <p className="ft-16 fw-500">Select a Plan</p>
                    <PlanCards
                      {...formProps}
                      plans={planApiData.transferRequestDetails}
                      fields={fields}
                      isTransfer={true}
                      disable={
                        get(transferDetails, "transferStatus") !== undefined
                      }
                      selectedPlan={selectedPlan}
                      setSelectedPlan={setSelectedPlan}
                    />
                    <p className="ft-16 fw-500">Sources</p>
                    <div className="d-flex">
                      <SourceCard
                        {...formProps}
                        data={sourceData}
                        onChange={onChange}
                      />
                    </div>
                    <InvestmentDetails
                      {...formProps}
                      fields={fields}
                      data={sourceData}
                      hideCard={hideCard}
                    />
                  </div>
                </ManageDistributionLayout>
              </LoaderWrapper>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
export default TransferRequestContainer;
